import React from "react";
import { Theme, themeOptions } from "@commonsku/styles";
import { Box, Provider } from "@commonsku/design-system";
import { ToastContainer } from "react-toastify";
import '../../scss/css/react-toastify.css';
import ErrorBoundary from "../components/ErrorBoundary";
import Header from "./Header";
import MainSection from "./MainSection";
import Overlay from "../components/Overlay";
import { useSelector } from "react-redux";
import { getPopups } from "../selectors";

import { GlobalStyle } from "./DashboardApp";
import WorkflowAutomationsRouter from "../components/workflow-automations/WorkflowAutomationsRouter";

const WorkflowAutomationsApp = () => {
  const popups = useSelector(getPopups);

  return (
    <Theme theme={themeOptions}>
      <GlobalStyle />
      <ErrorBoundary>
        <Header />
        <MainSection>
          <div className="main-content">
            <Provider>
              <Box fontFamily="body">
                <WorkflowAutomationsRouter />
              </Box>
            </Provider>
            <ToastContainer
              autoClose={3000}
              hideProgressBar={true}
            />
          </div>
        </MainSection>
        <Overlay popups={popups} />
      </ErrorBoundary>
    </Theme>
  );
};

export default WorkflowAutomationsApp;
